import { jsxs as i, Fragment as e, jsx as r } from "react/jsx-runtime";
import p from "styled-components";
import l from "../TooltipInfo/TooltipInfo.js";
const n = p(l).withConfig({
  displayName: "StyledTooltipInfo"
})([
  "&&{margin:-6px 0px 0px 4px;pointer-events:initial;}"
]), a = ({ label: o, tooltip: t }) => t ? /* @__PURE__ */ i(e, {
  children: [
    o,
    /* @__PURE__ */ r(n, {
      title: t,
      arrow: !0
    })
  ]
}) : o;
a.displayName = "LabelTooltip";
export {
  a as default
};
